import { ExternalLink } from "lucide-react";
import { ShareButton } from "@/components/ShareButton";
import { CalendarButton } from "@/components/CalendarButton";

export const LaunchActions = ({ launch }) => (
  <div className="flex items-center gap-3 flex-wrap">
    {launch.webcast ? (
      <a
        href={launch.webcast}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary flex items-center gap-2"
        data-testid="watch-webcast-btn"
      >
        <ExternalLink className="w-4 h-4" strokeWidth={1.5} />
        Watch Webcast
      </a>
    ) : (
      <span className="btn-outline opacity-50 cursor-not-allowed">
        Webcast link pending
      </span>
    )}
    <CalendarButton launch={launch} className="p-3" />
    <ShareButton launch={launch} className="p-3" />
  </div>
);
